export enum MIXPANEL_EVENT_TYPES {
    CLICKED = 'Clicked',
    CREATED = 'Created',
    OPENED = 'Opened',
    CLOSED = 'Closed',
    CANCELED = 'Canceled',
    REOPENED = 'Reopened',
    EDITED = 'Edited',
    RIGHT_CLICK = 'RightClick',
    LEFT_CLICK = 'LeftClick',
    SENT = 'Sent',
    QUESTION_ANSWERED = 'QuestionAnswered',
    QUESTION_REMOVED = 'QuestionRemoved',
    PREVIEW = 'Preview',
    FULLSCREEN = 'FullScreen',
    RESET_CONFIRMED = 'ResetConfirmed',
    DOWNLOAD = 'Download',
    ERROR_MAX_RESPONSES = 'Error.MaxResponses',
    ERROR_MAX_POLLS = '.Error.MaxPolls',
    ERROR_ENDED_LIVE = 'Error.EndedLive',
    ERROR_REFRESH_PAGE = 'RefreshPage',
    ERROR_FIREWALL = 'Firewall',
    ERROR_WEBSOCKET = 'Websoket',
    ERROR_WEBSOCKET_CLOSE_PORT = 'Websocket.ClosePort',
    SLIDE_DECK_CHANGED = 'SlideChanged.SlideDeck',
    SAVED_CREATE = 'Saved.Create',
    SAVED_EDIT = 'Saved.Edit',
    ON = 'On',
    OFF = 'Off',
    ADD_RESULTS_SLIDE = 'AddResultsSlide',
    ERROR_ONE_POLL_OPENED = 'Error.OnePollOpened',
    SEND_ALL = 'SendAll',
    PAGING = 'Paging',
    SORTING_NAME = 'SortingName',
    SORTING_EMAIL = 'SortingEmail',
    SORTING_ARRIVAL = 'SortingArrival',
    UNANSWERED_TAB_CLICKED = 'UnansweredTab.Clicked',
    ANSWERED_TAB_CLICKED = 'AnsweredTab.Clicked',
    REMOVED_TAB_CLICKED = 'RemovedTab.Clicked',
    MOVE_TO_UNANSWERED= 'MoveToUnanswered',
    MOVED_BY_ARROW = 'MovedByArrow',
    PRIORITIZED_COLUMN = 'PrioritizedColumn',
    PRESENTER_COLUMN = 'PresenterColumn',
    FOR_REVIEW_COLUMN = 'ForReviewColumn',
    CLICKED_ACCESS = 'Clicked.Access',
    TOPIC_EDITED = 'Topic.Edited',
}

export enum MIXPANEL_EVENT_IDENTIFIERS {
    REVIEW_MODE = 'ReviewMode',
    POLLS_TAB = 'PollsTab',
    POLLS = 'Polls',
    SLIDE_CHANGED = 'SlideChanged',
    QATab = 'Q&ATab',
    MESSAGES_WIDGET = 'MessagesWidget',
    MESSAGES = 'Messages',
    PRESENTERS_TAB = 'PresentersTab',
    SIGN_IN = 'SignIn',
    QA = 'Q&A',
    ATTENDEES_TAB = 'AttendeesTab',
    ERROR = 'Error',
    LAUNCH_PREVIEW = 'LaunchPreview',
    PRESENTER = 'Presenter',
    ATTENDEES = 'Attendees',
    QA_AI_AUTO_ANALYSIS_TOPIC_EDITED = 'Q&A Auto Analysis Topic Edited '
}

export interface IMixpanelService {
    track: (identifier: MIXPANEL_EVENT_IDENTIFIERS, type: MIXPANEL_EVENT_TYPES, options?: Record<string, unknown>) => void;
}
